import { render, staticRenderFns } from "./ClientsDetail.vue?vue&type=template&id=33976958&scoped=true&"
import script from "./ClientsDetail.vue?vue&type=script&lang=js&"
export * from "./ClientsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClientsDetail.vue?vue&type=style&index=0&id=33976958&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33976958",
  null
  
)

export default component.exports